import React from 'react';
import styles from './Icon.module.css';

class Icon extends React.Component {
  render() {
    const { name, size = 18, className = '', style } = this.props;
    return (
      <span
        className={'material-symbols-rounded ' + styles.icon + (className ? ' ' + className : '')}
        style={{ fontSize: size, ...style }}
      >
        {name}
      </span>
    );
  }
}

export default Icon;
